<template>
<div class="d-flex flex-column">
    <b-overlay :show="busy"
      rounded
      opacity="0.6"
      spinner-small>

      <div class="Subed_Package">
        <div class="Desc">
            {{$t("lbl_EMPBE_SubedPackage")}}
        </div>
        <div class="d-flex my-3 flex-wrap SubedPackageWrapper ">
            <a v-b-toggle.PackageInfo class="btn" 
                v-for="item in this.PackageData"
                @click="ShowPackageSideBar(item)"
                t_label="EMPBE_AdInfoCenter_MainTab_OverView"
                >
                {{ GetPackageName(item) }}
            </a>
        </div>
        <SponsorSideBar :LangId="this.langid" :CurPackage="this.CurClickedPackage" ref="sidebar"></SponsorSideBar>

    </div>

    <div class="table">
        <b-table id="OverViewTable" hover :items="TabelItem" :fields="TableField" :tbody-tr-class="trClass" >
            <template #head(EMPTotal)="data">
                <span v-html="data.label"></span>
            </template>
            <template #head(CPSTotal)="data">
                <span v-html="data.label"></span>
            </template>
            
            <template #cell(Entitlement)="data">
                <i v-if="data.value" class="fa fa-check-circle"></i>
                <i v-if="!data.value" class="fa text-secondary fa-minus-circle"></i>
            </template>

            <template #cell(Status)="AdStatus">
                <h4>
                    <span v-if="AdStatus.value == 'P'" class="badge badge-primary" > {{ $t("lbl_EMPBE_Pending")}} </span>
                    <span v-if="AdStatus.value == 'A'" class="badge badge-success" > {{ $t("lbl_EMPBE_isActivate") }} </span>
                    <span v-if="AdStatus.value == 'R' " class="badge badge-danger" > {{ $t("lbl_EMPBE_Rejected") }} </span>
                    <span v-if="!AdStatus.value" class="badge badge-light" > N / A </span>
                    <!-- <span v-if="!AdStatus.value" class="badge badge-light" > {{ $t("lbl_EMPBE_NotSubmitYet") }} </span> -->
                </h4>
            </template>

            <template #cell(Action)="data" >
                
                <b-button class="tButton" @click="$emit('JumpToAds',data.value.TabID )" 
                v-if="data.value.IsManage" variant="outline-dark"
                :t_label="'EMPBE_AdInfoCenter_Manage'" >
                {{$t('lbl_EMPBE_Manage')}}
                </b-button>

                <b-button  v-b-toggle.learnMore_Sidebar class="tButton Contact_Sales text-white"
                 v-if="!data.value.IsManage"  variant="Orange" 
                 :t_label="'EMPBE_AdInfoCenter_ContactSales'">
                 {{ $t('lbl_EMPBE_ContactSales') }}
                </b-button>

            </template>
         
        </b-table>
    </div>

    </b-overlay>

</div>
</template>

<script>
import { userService, adService, CompanyInfoService } from '../../../_services';
import SponsorSideBar from "./SponsorSideBar.vue";
import { isShowAdOverview } from '../../../constants/config';
export default{
    components:{
        SponsorSideBar
    },
    data(){
        return{
            busy: true,
            CurClickedPackage: "",
            eBoothGrade: '',
            eBoothExpiryDate: '',
            packageCode: '',
            packageExpiryDate: '',
            eBoothData: {},
            PackageData: [],
            PaymentItemData: [],
            loadingCompany: false,
            loadingSponsor: false,
            moreThanOneSponser: false,
            TabelItem: [

            ],
            TableField: [
                {key:'Type', label: this.$t('lbl_EMPBE_AdType')}
                ,{key:'Entitlement', label: this.$t('lbl_EMPBE_Entitlement')}
                ,{key:'Total', label: this.$t('lbl_EMPBE_TotalAdItem')}
                ,{key:'Status', label: this.$t('lbl_EMPBE_AdStatus')}
                ,{key:'EMPTotal', label: this.$t('lbl_EMPBE_AdNoInEmarket'), tdClass: "PreLine"}
                ,{key:'CPSTotal', label: this.$t('lbl_EMPBE_AdNoInChinaplas'), tdClass: "PreLine"}
                ,{key:'Action', label: this.$t('lbl_EMPBE_Action')}
            ],
            //Hard code Package sets
            BannerAdsIds:[4, 7, 12, 13, 15, 21, 22, 23, 24, 25, 26],

            ButtonAdsIds:[3, 6, 14],

            CatListAdsIds: [20],

            LandingAdsIds: [8],
            
            PriorityAdsIds: [19],

            StarsAdsIds: [9],

            StickyAdsIds: [10],

            VideoAdsIds: [11, 17],

        }
    },
    computed:{
        user() {
            return this.$store.state.authentication.user;
        },
        langid() {
            return localStorage.getItem("currentLangId")
        }
    },
    mounted(){
        this.LoadAdsPackages()
    },
    methods:{
        LoadTableItem(){
            //[29112023][SJP]Hard code table data for overview 
            this.FilterAdPackageByType(this.BannerAdsIds, "lbl_EMPBE_BannerAd", 0);
            this.FilterAdPackageByType(this.StickyAdsIds , "lbl_EMPBE_StickyAd", 1);
            this.FilterAdPackageByType(this.ButtonAdsIds, "lbl_EMPBE_ButtonAd", 2);
            this.FilterAdPackageByType(this.LandingAdsIds , "lbl_EMPBE_LandingPageAd", 3);
            this.FilterAdPackageByType(this.VideoAdsIds, "lbl_EMPBE_VideoAd", 4);
            this.FilterAdPackageByType(this.StarsAdsIds , "lbl_EMPBE_StarAd", 5);
            this.FilterAdPackageByType(this.CatListAdsIds, "lbl_EMPBE_CatListAd", 6);         
            this.FilterAdPackageByType(this.PriorityAdsIds, "lbl_EMPBE_priorityAds", 7);
            

        },
        LoadAdsPackages(){
            var that = this;
            adService.GetPackageByCompanyId({ empCompanyId: this.user.empCompanyId }).then((res => {               
                if (res.isSuccessful) {
                    var data = res.data;

                    if (data.basicInfo) {
                        that.eBoothData = data.basicInfo;
                        that.PaymentItemData = data.paymentItemInfo;
                    }
                    if (data.packageInfo && data.packageInfo.length) {
                        var _item = {
                        packageGroup: data.packageInfo[0].packageGroup,
                        packageNameEN: data.packageInfo[0].packageNameEN,
                        packageNameSC: data.packageInfo[0].packageNameSC,
                        packageNameTC: data.packageInfo[0].packageNameTC,
                        data: data.packageInfo
                        }
                        that.PackageData.push(_item);
                    }
                    if (data.sponsorshipInfo && data.sponsorshipInfo.length) {
                        var packageNameArr = [];
                        data.sponsorshipInfo.forEach(element => {
                        if (packageNameArr.filter( x=> x.packageGroup == element.packageGroup).length == 0) {
                            let _item={
                                packageGroup : element.packageGroup,
                                packageNameEN: element.packageNameEN,
                                packageNameSC: element.packageNameSC,
                                packageNameTC: element.packageNameTC,
                            }
                            packageNameArr.push(_item);
                        }
                        });
                        packageNameArr.forEach(element => {
                        var _item = {
                            packageGroup : element.packageGroup,
                            packageNameEN: element.packageNameEN,
                            packageNameSC: element.packageNameSC,
                            packageNameTC: element.packageNameTC,
                            data: data.sponsorshipInfo.filter(x => x.packageGroup == element.packageGroup)
                        }
                        that.PackageData.push(_item);
                        });
                    }
                    that.moreThanOneSponser = that.PackageData.length > 1;

                    this.LoadTableItem();
                }
            })).finally(() => {
                that.loadingSponsor = false
                that.busy = false
            })
        },
        GetPackageName(PackageItem){
             return this.langid == 1252 ? PackageItem.packageNameEN : this.langid == 950 ? PackageItem.packageNameTC : PackageItem.packageNameSC
        },
        FilterAdPackageByType(Ids, WR_AdTypeName, TabID ){
            var FilteredItem = [];
            var curDate = new Date();
            this.PackageData.forEach( Package => {
                FilteredItem.push(
                    ...(Package.data).filter(x =>Ids.includes(x.adPackageId)
                     && curDate >= new Date(x.effectiveDateFrom)
                      && curDate <= new Date(x.effectiveDateTo) 
                      )
                )
                
            })

            // Take unique item  to avoid repeated ads
            
            var uniqueAdsItem =  [...new Map(FilteredItem.map(x=> [x["permissionHeaderType"], x])).values()]
            // console.log(this.$t(WR_AdTypeName))
            // console.log(uniqueAdsItem)
            
            //Add to tableitem array
            this.TabelItem.push({
                Type: this.$t(WR_AdTypeName),
                Entitlement: uniqueAdsItem.length > 0,
                Total: uniqueAdsItem.length,
                Status: adService.AdRecordsToApprovalInfo(uniqueAdsItem).statusCode,
                EMPTotal: this.GetAdsNameByPlatform(uniqueAdsItem, "EMP"),
                CPSTotal:  this.GetAdsNameByPlatform(uniqueAdsItem, "CPSOL"),
                Action: {IsManage: uniqueAdsItem.length > 0 ,TabID: TabID}
            })

        },
        GetAdsNameByPlatform(AdsItem ,PlatForm){
            var output= ""
            var NameLang = this.langid == 1252 ? "itemNameEN" : this.langid == 950 ? "itemNameTC" : "itemNameSc"
            var PlatFormAdsItem = AdsItem.filter(x=> x.platformType == PlatForm)
            
            PlatFormAdsItem.forEach(x => {
                output += x[NameLang]
                output += "\n"
            })
            return output ? output : "-"
        },
        trClass(item, type){
            if(!item|| type !=='row'){
                return
            } 
            else{
                return "TableRowClass"
            }
            
        },
        imagePath() {
            var langPath = this.langid == 1252 ? "en" : "cn";
            return 'https://cdn.adsalecdn.com/EMP/Backend/Images/Dashboard/' + this.data[0].packageGroup + '_' + langPath + '.jpg'
        },
        ShowPackageSideBar(item){
            this.CurClickedPackage = item.packageGroup
        }

    }
}
</script>

<style>
    .Subed_Package > .Desc{
        font-family: Roboto;
        font-size: 16px;
        font-weight: 700;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: left;

    }
    .SubedPackageWrapper{
        gap:12px;
    }
    .SubedPackageWrapper > a{
        font-family: Roboto;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: center;
        border: 1px solid #666666;
        padding: 12px;
        min-width:100px;
        border-radius: 10px;
        cursor: pointer;

        &:hover{
            background-color: black;
            color:white;
        }
    }
    .PreLine{
        white-space: pre-line;
    }
    .TableRowClass{
        font-family: Roboto;
        font-size: 14px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0em;
        text-align: left;
        color: #151515;

    }
    .tButton{
        width:135px;
    }
    .EMPText{
        color:#CB242B;
    }
    .CPSText{
        color:#615090;
    }
    /* Bootstrap vue table don't have global thead styling with code, use css selector instead*/
    #OverViewTable thead > tr > th{
        font-family: Roboto;
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        color: #666666;
        border-top-color:white;

    }

</style>